import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MoreIcon from "@mui/icons-material/MoreVert";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { RightNavItems } from "./right-nav-items";
import Link from "next/link";

const MobileMenu = ({
  isMenuOpen,
  mobileMoreAnchorEl,
  handleMobileMenuOpen,
  handleMobileMenuClose,
  handleMenuOpen,
}) => {
  const handleMenuChange = (e, type) => {
    handleMenuOpen(e, type);
  };
  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {RightNavItems?.map((item) => (
        <MenuItem
          key={item?.id}
          sx={{ color: "var(--bs-primary)" }}
          name={item?.name}
          onClick={
            item?.haspopup ? (e) => handleMenuChange(e, item?.name) : null
          }
        >
          <Link href={item?.link || "#"}>
            <IconButton
              size="large"
              aria-label={item?.name}
              color="inherit"
              aria-haspopup={item?.haspopup}
            >
              {item?.icon}
            </IconButton>
            <p className="mb-0">{item?.title}</p>
          </Link>
        </MenuItem>
      ))}
    </Menu>
  );
  return (
    <>
      {/* need this box to place menu icon on right end */}
      <Box sx={{ flexGrow: { xs: 1, sm: 0 } }} />
      {/* on mobile screen  right hand icons*/}
      <Box sx={{ display: { xs: "flex", sm: "none" } }}>
        <IconButton
          size="large"
          aria-label="show more"
          aria-controls={mobileMenuId}
          aria-haspopup="true"
          onClick={handleMobileMenuOpen}
          color="inherit"
        >
          <MoreIcon />
        </IconButton>
      </Box>

      {renderMobileMenu}
    </>
  );
};

export default MobileMenu;
